export const siteInfo = {
  name: "CL社区",
  tagline: "发现优质内容，连接活跃圈子",
  description: "CL社区是深受用户喜爱的在线交流平台，汇聚技术分享、生活讨论、资源交流等多个板块，致力于为每一位成员打造温暖、专业、高效的交流空间。",
  established: "2018",
  members: "1,280,000+",
  posts: "8,560,000+",
  dailyActive: "58,000+",
  forumCount: "32",
};

export const categories = [
  {
    slug: "tech-discussion",
    name: "技术交流",
    icon: "ri-code-s-slash-line",
    description: "编程开发、前沿技术、开源项目讨论",
    postCount: 125600,
    color: "accent",
  },
  {
    slug: "life-sharing",
    name: "生活分享",
    icon: "ri-heart-line",
    description: "日常生活、兴趣爱好、情感交流",
    postCount: 98300,
    color: "secondary",
  },
  {
    slug: "resource-exchange",
    name: "资源交流",
    icon: "ri-folder-transfer-line",
    description: "学习资源、工具软件、实用网站分享",
    postCount: 87400,
    color: "primary",
  },
  {
    slug: "digital-creative",
    name: "数码创意",
    icon: "ri-macbook-line",
    description: "数码产品、设计创作、多媒体内容",
    postCount: 65200,
    color: "accent",
  },
  {
    slug: "game-entertainment",
    name: "游戏娱乐",
    icon: "ri-gamepad-line",
    description: "游戏攻略、电竞资讯、动漫讨论",
    postCount: 112300,
    color: "secondary",
  },
  {
    slug: "study-education",
    name: "学习教育",
    icon: "ri-book-open-line",
    description: "考试备考、技能提升、知识科普",
    postCount: 76800,
    color: "primary",
  },
  {
    slug: "workplace-career",
    name: "职场发展",
    icon: "ri-briefcase-line",
    description: "求职招聘、职场经验、行业动态",
    postCount: 54300,
    color: "accent",
  },
  {
    slug: "secondhand-market",
    name: "二手交易",
    icon: "ri-shopping-bag-3-line",
    description: "闲置转让、好物推荐、交易交流",
    postCount: 45900,
    color: "secondary",
  },
];

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  author: { name: string; avatar: string };
  coverImage: string;
  publishedAt: string;
  views: number;
  comments: number;
  likes: number;
  tags: string[];
  isHot: boolean;
  isPinned: boolean;
}

export const articles: Article[] = [
  {
    id: "article-1",
    title: "2026年最值得关注的10个前端开发趋势",
    excerpt: "从前端框架演进到WebAssembly的普及，本文深入分析了2026年前端开发领域最值得关注的十大技术趋势，帮助开发者把握行业脉搏。",
    content: `<h2>引言</h2><p>2026年，前端开发领域继续以惊人的速度演进。从新的JavaScript运行时到AI驱动的开发工具，前端生态系统正在经历一场深刻的变革。本文将深入探讨今年最值得关注的十个前端开发趋势。</p><h2>1. WebAssembly进入主流</h2><p>WebAssembly (Wasm) 在2026年迎来了真正的爆发。越来越多的开发者开始将性能关键的计算任务编译为Wasm模块，在前端实现接近原生的执行效率。Rust和Go成为编写Wasm模块的首选语言，而WASI（WebAssembly System Interface）的成熟也使得在浏览器中运行复杂的系统级应用成为可能。</p><h2>2. AI辅助开发工具全面普及</h2><p>GitHub Copilot、Cursor、Claude等AI编程助手已经成为开发者日常工作流中不可或缺的一部分。2026年，这些工具的能力进一步扩展，不仅能够生成代码，还能理解项目架构、自动修复bug、优化性能，甚至直接生成完整的组件库。</p><h2>3. React Server Components成熟</h2><p>React Server Components（RSC）在经历了数年的探索后，终于在2026年迎来了广泛的采用。Next.js 16和Remix 3都对RSC提供了出色的支持，使得开发者能够在不牺牲交互性的前提下大幅减少客户端JavaScript的体积。</p><h2>4. CSS容器查询广泛应用</h2><p>随着所有主流浏览器对容器查询的全面支持，响应式设计进入了一个新时代。开发者不再需要依赖视口媒体查询，而是可以根据父容器的大小来调整组件的布局和样式，这极大地提升了组件的可复用性。</p><h2>5. TypeScript成为默认选择</h2><p>TypeScript已经不再是一个"可选项"，而是几乎所有新项目的默认选择。2026年的TypeScript 6.0版本带来了更强大的类型推断和更快的编译速度，进一步巩固了其在JavaScript生态系统中的核心地位。</p><h2>结语</h2><p>2026年的前端世界充满了机遇和挑战。无论你是经验丰富的资深开发者还是刚入门的新手，跟上这些趋势将帮助你在技术浪潮中保持竞争力。</p>`,
    category: "tech-discussion",
    categoryName: "技术交流",
    author: { name: "程序猿小明", avatar: "https://readdy.ai/api/search-image?query=Professional%20male%20avatar%20portrait%20in%20tech%20style%20with%20simple%20clean%20background%20warm%20lighting%20modern%20minimalist%20profile%20photo&width=100&height=100&seq=avatar-1&orientation=squarish" },
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20coding%20workspace%20with%20laptop%20showing%20colorful%20code%20editor%20on%20minimalist%20desk%20with%20warm%20ambient%20lighting%20clean%20aesthetic%20composition%20tech%20vibe%20editorial%20photography%20style&width=1200&height=600&seq=article-cover-1&orientation=landscape",
    publishedAt: "2026-08-05",
    views: 38600,
    comments: 256,
    likes: 1820,
    tags: ["前端开发", "技术趋势", "WebAssembly", "React", "TypeScript"],
    isHot: true,
    isPinned: true,
  },
  {
    id: "article-2",
    title: "从零搭建个人博客：新手完全指南",
    excerpt: "想拥有一个属于自己的博客吗？本文从域名选择、服务器配置到内容创作，手把手教你搭建一个美观实用的个人博客网站。",
    content: `<h2>为什么要搭建个人博客？</h2><p>在社交媒体泛滥的时代，拥有一个属于自己的博客不仅能展示你的专业技能，更能建立起长期的个人品牌。你的博客是你完全掌控的数字资产，不受任何平台算法的限制。</p><h2>第一步：确定博客定位</h2><p>在开始搭建之前，先想清楚你的博客要写什么内容。是技术分享、生活记录、还是专业领域的深度文章？明确的定位会帮助你做出更好的设计和技术选择。</p><h2>第二步：选择技术方案</h2><p>对于新手来说，推荐使用静态网站生成器如Hugo、Hexo或Astro。这些工具上手简单，生成速度快，而且部署成本极低。如果你想要更灵活的功能，WordPress仍然是一个不错的选择。</p><h2>第三步：内容创作策略</h2><p>好的内容是博客成功的关键。建议从自己最熟悉的领域开始写起，保持每周至少一篇的更新频率。不要过分追求完美，先写出来再不断迭代优化。</p><h2>总结</h2><p>搭建个人博客是一个值得投入的项目。它不仅是一个展示平台，更是一个学习和成长的过程。现在就开始你的博客之旅吧！</p>`,
    category: "tech-discussion",
    categoryName: "技术交流",
    author: { name: "深夜码字人", avatar: "https://readdy.ai/api/search-image?query=Young%20creative%20person%20avatar%20portrait%20with%20glasses%20casual%20style%20warm%20lighting%20simple%20background%20modern%20minimalist%20profile&width=100&height=100&seq=avatar-2&orientation=squarish" },
    coverImage: "https://readdy.ai/api/search-image?query=Cozy%20home%20office%20desk%20with%20notebook%20and%20coffee%20cup%20warm%20sunlight%20through%20window%20minimalist%20aesthetic%20blogging%20creative%20workspace%20editorial%20photography%20clean%20composition&width=1200&height=600&seq=article-cover-2&orientation=landscape",
    publishedAt: "2026-08-04",
    views: 25300,
    comments: 189,
    likes: 1340,
    tags: ["个人博客", "建站教程", "内容创作", "新手入门"],
    isHot: true,
    isPinned: false,
  },
  {
    id: "article-3",
    title: "分享我的极简桌面布置：提升工作效率的秘密",
    excerpt: "一张干净的桌子，一套合理的设备布局，能让你的工作效率翻倍。来看看我的极简桌面布置方案和背后的设计理念。",
    content: `<h2>为什么要追求极简桌面？</h2><p>一个整洁有序的工作环境不仅能让心情愉悦，更能显著提升工作效率。研究表明，杂乱的桌面会增加认知负担，降低专注力。极简桌面的核心不是'东西少'，而是'每件物品都有其存在的意义'。</p><h2>核心设备清单</h2><p>我的桌面核心是一台27寸4K显示器，搭配升降桌和人体工学椅。笔记本使用支架竖放节省空间。键盘选择了机械键盘，鼠标则是垂直鼠标以保护手腕。所有这些设备都通过一个雷电拓展坞连接，桌面只有一根线。</p><h2>收纳与线缆管理</h2><p>线缆管理是极简桌面的关键。我使用了桌下线缆槽和魔术贴扎带将所有线缆隐藏起来。桌面上看不见任何多余的线缆，这让整个空间看起来非常干净。</p><h2>绿植与灯光</h2><p>一盆小型绿植和暖色调的屏幕挂灯为桌面增添了生机和温馨感。好的照明不仅能保护视力，还能营造专注的氛围。</p>`,
    category: "life-sharing",
    categoryName: "生活分享",
    author: { name: "极简生活家", avatar: "https://readdy.ai/api/search-image?query=Minimalist%20lifestyle%20person%20avatar%20portrait%20clean%20aesthetic%20warm%20neutral%20background%20modern%20simple%20profile%20photo&width=100&height=100&seq=avatar-3&orientation=squarish" },
    coverImage: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20desk%20setup%20with%20monitor%20keyboard%20and%20small%20plant%20warm%20ambient%20lighting%20modern%20workspace%20aesthetic%20editorial%20photography%20style&width=1200&height=600&seq=article-cover-3&orientation=landscape",
    publishedAt: "2026-08-03",
    views: 42100,
    comments: 312,
    likes: 2560,
    tags: ["桌面布置", "极简生活", "工作效率", "数码好物"],
    isHot: true,
    isPinned: false,
  },
  {
    id: "article-4",
    title: "2026年值得收藏的50个优质学习资源网站",
    excerpt: "精心整理50个覆盖编程、设计、语言、学术等多个领域的优质学习资源网站，每一个都经过实际使用验证，助你高效学习。",
    content: `<h2>编程开发类</h2><p>1. freeCodeCamp - 完全免费的编程学习平台，涵盖前端、后端、数据科学等完整课程。<br/>2. The Odin Project - 开源的全栈开发课程，项目驱动式学习。<br/>3. LeetCode - 算法和数据结构练习的首选平台。<br/>4. Codecademy - 交互式编程学习，适合零基础入门。……</p><h2>设计创意类</h2><p>1. Dribbble - 全球设计师作品展示平台，获取灵感的好地方。<br/>2. Behance - Adobe旗下的创意作品展示社区。<br/>3. Canva Design School - 免费的设计教程和资源。……</p><h2>语言学习类</h2><p>1. Duolingo - 游戏化的语言学习应用。<br/>2. italki - 一对一在线语言教学平台。……</p>`,
    category: "resource-exchange",
    categoryName: "资源交流",
    author: { name: "知识搬运工", avatar: "https://readdy.ai/api/search-image?query=Bookish%20scholar%20person%20avatar%20portrait%20with%20warm%20lighting%20simple%20background%20academic%20vibe%20modern%20profile&width=100&height=100&seq=avatar-4&orientation=squarish" },
    coverImage: "https://readdy.ai/api/search-image?query=Organized%20bookshelf%20with%20colorful%20books%20and%20laptop%20on%20wooden%20desk%20warm%20lighting%20study%20atmosphere%20editorial%20photography%20clean%20composition&width=1200&height=600&seq=article-cover-4&orientation=landscape",
    publishedAt: "2026-08-02",
    views: 56800,
    comments: 423,
    likes: 3890,
    tags: ["学习资源", "网站推荐", "在线教育", "知识整理"],
    isHot: true,
    isPinned: false,
  },
  {
    id: "article-5",
    title: "摄影新手入门：掌握这5个构图技巧就够了",
    excerpt: "好的构图是优秀照片的基础。本文介绍5个简单实用的摄影构图技巧，无需昂贵设备，用手机也能拍出大片质感。",
    content: `<h2>1. 三分法则</h2><p>将画面用两条横线和两条竖线分成九个相等的方格，将主体放在交叉点上。这是最基础也最实用的构图技巧，几乎适用于所有拍摄场景。</p><h2>2. 引导线</h2><p>利用画面中的线条（道路、栏杆、河流等）引导观众的视线指向主体，创造出深度感和方向感。</p><h2>3. 框架构图</h2><p>利用门框、窗户、树枝等自然形成的框架来包围主体，增强画面的层次感和趣味性。</p><h2>4. 对称构图</h2><p>对称的画面能给人以平衡、稳定的视觉感受。建筑摄影和水面倒影是运用对称构图的绝佳场景。</p><h2>5. 留白艺术</h2><p>适当的留白能让主体更加突出，给观众留下想象空间。极简风格的照片往往能产生强大的视觉冲击力。</p>`,
    category: "digital-creative",
    categoryName: "数码创意",
    author: { name: "快门手记", avatar: "https://readdy.ai/api/search-image?query=Photographer%20person%20avatar%20portrait%20with%20camera%20creative%20style%20warm%20lighting%20simple%20background%20modern%20profile&width=100&height=100&seq=avatar-5&orientation=squarish" },
    coverImage: "https://readdy.ai/api/search-image?query=Vintage%20camera%20on%20wooden%20table%20with%20warm%20sunlight%20soft%20shadows%20photography%20aesthetic%20minimalist%20composition%20editorial%20style&width=1200&height=600&seq=article-cover-5&orientation=landscape",
    publishedAt: "2026-08-01",
    views: 32100,
    comments: 198,
    likes: 2150,
    tags: ["摄影技巧", "构图入门", "手机摄影", "新手教程"],
    isHot: true,
    isPinned: false,
  },
  {
    id: "article-6",
    title: "《星空之下》深度评测：年度最令人惊喜的独立游戏",
    excerpt: "在3A大作扎堆的2026年，这款来自三人小团队的独立游戏却成了最大黑马。40小时的深度体验告诉你为什么它值得购买。",
    content: `<h2>游戏简介</h2><p>《星空之下》是一款融合了Roguelike元素和开放世界探索的独立游戏。玩家扮演一位星际探险家，在随机生成的星系中探索未知星球、收集资源、建造基地，并揭开宇宙中隐藏的秘密。</p><h2>画面与音乐</h2><p>游戏采用了精美的手绘风格画面，每个星球都有独特的生态系统和色彩搭配。背景音乐由获得过格莱美提名的作曲家操刀，星际旅行时的配乐尤其令人沉醉。</p><h2>玩法深度</h2><p>游戏的核心循环设计非常巧妙。探索-收集-建造-升级的节奏控制得恰到好处，每次登陆新星球都充满新鲜感和期待。Roguelike元素的加入让每次游戏体验都独一无二。</p><h2>结论</h2><p>《星空之下》证明了好的游戏不在于团队规模和预算大小，而在于创意和用心。如果你喜欢探索和建造类游戏，这绝对是一款不容错过的作品。</p>`,
    category: "game-entertainment",
    categoryName: "游戏娱乐",
    author: { name: "老玩家日记", avatar: "https://readdy.ai/api/search-image?query=Gamer%20person%20avatar%20portrait%20casual%20style%20warm%20lighting%20simple%20background%20modern%20profile%20photo&width=100&height=100&seq=avatar-6&orientation=squarish" },
    coverImage: "https://readdy.ai/api/search-image?query=Starry%20night%20sky%20digital%20art%20with%20spaceship%20silhouette%20game%20concept%20art%20style%20atmospheric%20warm%20colors%20cinematic%20composition&width=1200&height=600&seq=article-cover-6&orientation=landscape",
    publishedAt: "2026-07-31",
    views: 28900,
    comments: 345,
    likes: 1870,
    tags: ["独立游戏", "游戏评测", "星空之下", "Roguelike"],
    isHot: true,
    isPinned: false,
  },
  {
    id: "article-7",
    title: "考研二战上岸经验分享：从失败到成功的350天",
    excerpt: "第一次考研失利后，我花了350天时间调整策略、重新出发。这里分享我的完整备考计划和心路历程，希望能给正在备考的你一些力量。",
    content: `<h2>一战失利后的反思</h2><p>第一次考研失败后，我没有急于开始二战复习，而是花了一周时间认真复盘。我发现最大的问题不是不够努力，而是方法不对和心态失衡。每天学习12小时但效率低下，盲目追求进度而忽略了理解深度。</p><h2>二战备考策略</h2><p>二战期间，我将复习分为三个阶段：基础巩固期（3个月）、强化提升期（4个月）、冲刺模拟期（3个月）。每个阶段都有明确的目标和考核标准。同时，我坚持每周休息一天，保证充足的睡眠和运动时间。</p><h2>心态调整</h2><p>二战最大的挑战不是知识，而是心态。我学会了接受不确定性，不再把考研当作人生的唯一出路。这种心态的转变反而让我更加专注和高效。</p><h2>结果与感悟</h2><p>最终，我以专业排名第三的成绩成功上岸。回顾这350天，我想说的是：失败并不可怕，可怕的是失败后失去了重新出发的勇气。</p>`,
    category: "study-education",
    categoryName: "学习教育",
    author: { name: "追光者小李", avatar: "https://readdy.ai/api/search-image?query=Young%20student%20avatar%20portrait%20studious%20look%20warm%20lighting%20simple%20background%20modern%20minimalist%20profile&width=100&height=100&seq=avatar-7&orientation=squarish" },
    coverImage: "https://readdy.ai/api/search-image?query=Study%20desk%20with%20stack%20of%20books%20and%20notes%20late%20night%20warm%20lamp%20light%20academic%20atmosphere%20editorial%20photography%20style&width=1200&height=600&seq=article-cover-7&orientation=landscape",
    publishedAt: "2026-07-30",
    views: 45600,
    comments: 567,
    likes: 4320,
    tags: ["考研经验", "二战上岸", "学习规划", "备考心得"],
    isHot: true,
    isPinned: false,
  },
  {
    id: "article-8",
    title: "职场新人必读：如何度过试用期的前30天",
    excerpt: "入职新公司的前30天决定了你在团队中的第一印象。这份详尽的30天生存指南，帮你平稳过渡试用期，快速融入新环境。",
    content: `<h2>第1周：观察与学习</h2><p>入职第一周的核心任务是观察和了解。了解公司的文化、团队的协作方式、项目的技术栈和业务流程。不要急于表现，先做好一个"好学生"，认真做笔记，主动请教。</p><h2>第2周：建立连接</h2><p>开始主动与团队成员建立连接。与每个同事进行一次一对一的简短交流，了解他们的工作内容和协作偏好。找到一位可以请教的"导师"，这对你的成长至关重要。</p><h2>第3-4周：展示价值</h2><p>在了解了团队和项目后，开始主动承担小任务并高质量完成。这是展示你价值的关键时期。同时，开始思考你可以为团队带来的独特贡献。</p><h2>常见误区</h2><p>新人最容易犯的错误包括：过度表现自己、不敢提问、忽视团队规范、只关注技术而忽略人际关系。避开这些坑，你的试用期会更加顺利。</p>`,
    category: "workplace-career",
    categoryName: "职场发展",
    author: { name: "职场老司机", avatar: "https://readdy.ai/api/search-image?query=Professional%20office%20worker%20avatar%20portrait%20confident%20look%20warm%20lighting%20simple%20background%20modern%20profile&width=100&height=100&seq=avatar-8&orientation=squarish" },
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20office%20workspace%20with%20people%20collaborating%20friendly%20atmosphere%20warm%20lighting%20professional%20environment%20editorial%20photography&width=1200&height=600&seq=article-cover-8&orientation=landscape",
    publishedAt: "2026-07-29",
    views: 34200,
    comments: 278,
    likes: 1650,
    tags: ["职场新人", "试用期", "入职指南", "职业发展"],
    isHot: false,
    isPinned: false,
  },
  {
    id: "article-9",
    title: "二手显卡选购指南：2026年哪些型号值得入手",
    excerpt: "显卡价格居高不下，二手市场成了很多玩家的选择。本文详细分析2026年二手显卡市场的行情和各型号的性价比排行。",
    content: `<h2>当前市场概况</h2><p>2026年的显卡市场虽然较前几年有所缓解，但高端新品价格依然不菲。二手显卡因此成为了不少装机玩家的首选。目前二手市场上，RTX 30系列和RX 6000系列的存量最大，价格也相对合理。</p><h2>性价比之王</h2><p>RTX 3070目前二手价格约1800-2200元，性能足以应对2K分辨率下的绝大多数游戏，是当前性价比最高的二手显卡之一。AMD方面，RX 6800以约2000元的价格提供了接近RTX 3080的光栅化性能。</p><h2>避坑指南</h2><p>购买二手显卡需要特别注意：检查是否为矿卡、核实保修状态、测试温度与噪音、确认接口完好。建议选择支持个人送保的品牌，购买前要求卖家提供GPU-Z截图和3DMark跑分。</p>`,
    category: "secondhand-market",
    categoryName: "二手交易",
    author: { name: "装机达人", avatar: "https://readdy.ai/api/search-image?query=Tech%20enthusiast%20avatar%20portrait%20with%20gadgets%20warm%20lighting%20simple%20background%20modern%20profile%20photo&width=100&height=100&seq=avatar-9&orientation=squarish" },
    coverImage: "https://readdy.ai/api/search-image?query=Graphics%20card%20closeup%20on%20clean%20surface%20with%20soft%20lighting%20tech%20hardware%20aesthetic%20editorial%20product%20photography%20style%20minimalist&width=1200&height=600&seq=article-cover-9&orientation=landscape",
    publishedAt: "2026-07-28",
    views: 18900,
    comments: 234,
    likes: 980,
    tags: ["二手显卡", "装机指南", "硬件选购", "性价比"],
    isHot: false,
    isPinned: false,
  },
  {
    id: "article-10",
    title: "下班后的2小时：培养副业技能的时间管理方法",
    excerpt: "每天下班后只有2小时自由时间？学会这套时间管理方法，让你高效利用碎片时间，稳步培养副业技能，实现收入多元化。",
    content: `<h2>重新定义"2小时"</h2><p>两小时看起来很短，但如果每天坚持，一年就是730小时。这个时间足够你掌握一门新技能或建立一个有收入的副业。关键在于你如何利用这两小时。</p><h2>时间分配策略</h2><p>我建议将每天的2小时分为三个部分：30分钟复习和巩固前一天的内容、60分钟学习新知识、30分钟实践和应用。这种'温故-学新-实践'的循环是最高效的学习方式。</p><h2>周末加速器</h2><p>周末可以利用连续的大块时间进行集中学习和项目实践。每个周末选择一个具体的小项目来完成，这能带来成就感和持续的动力。</p><h2>坚持的关键</h2><p>允许自己偶尔懈怠，但不要让懈怠成为习惯。找到学习伙伴互相监督，或者在社区记录你的学习进度，这些都是保持动力的有效方法。</p>`,
    category: "life-sharing",
    categoryName: "生活分享",
    author: { name: "斜杠青年小王", avatar: "https://readdy.ai/api/search-image?query=Energetic%20young%20professional%20avatar%20portrait%20creative%20style%20warm%20lighting%20simple%20background%20modern%20profile&width=100&height=100&seq=avatar-10&orientation=squarish" },
    coverImage: "https://readdy.ai/api/search-image?query=Evening%20study%20desk%20with%20laptop%20and%20notebook%20warm%20lamp%20light%20cozy%20home%20atmosphere%20editorial%20photography%20minimalist%20style&width=1200&height=600&seq=article-cover-10&orientation=landscape",
    publishedAt: "2026-07-27",
    views: 21300,
    comments: 187,
    likes: 1240,
    tags: ["时间管理", "副业技能", "自我提升", "碎片时间"],
    isHot: false,
    isPinned: false,
  },
  {
    id: "article-11",
    title: "Python自动化办公实战：10个让你准时下班的脚本",
    excerpt: "还在手动处理Excel报表和重复性文档工作？这10个Python自动化脚本帮你解放双手，让电脑替你完成枯燥的重复操作。",
    content: `<h2>1. 批量重命名文件</h2><p>使用os和glob模块，几行代码就能实现按照规则批量重命名文件夹中的所有文件，告别手动一个个修改。</p><h2>2. Excel报表自动化</h2><p>结合pandas和openpyxl，自动读取多个Excel文件，进行数据汇总、计算和格式化，一键生成周报和月报。</p><h2>3. 邮件自动发送</h2><p>使用smtplib批量发送个性化邮件，支持附件和HTML格式。配合Excel名单，实现精准群发。</p><h2>4. PDF文档处理</h2><p>PyPDF2和reportlab让你轻松实现PDF合并、拆分、提取文字和自动生成报告。</p><h2>…… 更多脚本详见正文</h2>`,
    category: "tech-discussion",
    categoryName: "技术交流",
    author: { name: "自动化达人", avatar: "https://readdy.ai/api/search-image?query=Python%20developer%20avatar%20portrait%20tech%20style%20warm%20lighting%20simple%20background%20modern%20profile%20photo&width=100&height=100&seq=avatar-11&orientation=squarish" },
    coverImage: "https://readdy.ai/api/search-image?query=Python%20code%20on%20computer%20screen%20with%20modern%20workspace%20warm%20lighting%20tech%20office%20aesthetic%20editorial%20photography%20style&width=1200&height=600&seq=article-cover-11&orientation=landscape",
    publishedAt: "2026-07-26",
    views: 41500,
    comments: 312,
    likes: 2780,
    tags: ["Python", "自动化办公", "效率工具", "编程实战"],
    isHot: true,
    isPinned: false,
  },
  {
    id: "article-12",
    title: "租房避坑指南：签合同前必须核对的20个细节",
    excerpt: "租房是每个城市打工人的必修课。本文整理了租房签约前必须仔细核对的20个关键细节，帮你避开常见的租房陷阱。",
    content: `<h2>看房阶段</h2><p>1. 检查房屋朝向和采光，下午2-3点是检验采光的最佳时间。<br/>2. 测试所有水电设施是否正常，包括热水器、空调、马桶冲水、下水道排水速度。<br/>3. 检查墙壁是否有渗水痕迹，特别是卫生间和厨房。<br/>4. 测试手机信号和宽带接口是否可用。<br/>5. 了解周边环境：噪音、安全、便利设施等。</p><h2>签约阶段</h2><p>6. 核实房东身份和房产证信息。<br/>7. 明确租金支付方式和押金退还条件。<br/>8. 确认物业费、水电燃气费的承担方式。<br/>9. 约定维修责任划分。<br/>10. 拍照记录房屋现状并与房东确认。……</p>`,
    category: "life-sharing",
    categoryName: "生活分享",
    author: { name: "租房小能手", avatar: "https://readdy.ai/api/search-image?query=Friendly%20person%20avatar%20portrait%20casual%20style%20warm%20lighting%20simple%20background%20modern%20minimalist%20profile&width=100&height=100&seq=avatar-12&orientation=squarish" },
    coverImage: "https://readdy.ai/api/search-image?query=Bright%20modern%20apartment%20interior%20with%20sunlight%20through%20window%20minimalist%20furniture%20warm%20cozy%20atmosphere%20editorial%20photography&width=1200&height=600&seq=article-cover-12&orientation=landscape",
    publishedAt: "2026-07-25",
    views: 51200,
    comments: 678,
    likes: 5210,
    tags: ["租房攻略", "生活指南", "合同细节", "避坑"],
    isHot: true,
    isPinned: false,
  },
];

export const aboutInfo = {
  brandIntro: "CL社区成立于2018年，由一群热爱互联网和知识分享的年轻人共同创建。经过8年的发展，CL社区已经成长为拥有超过128万注册用户的大型在线交流平台。我们的使命是「让有价值的交流发生在每个人身边」，致力于为中文互联网用户打造一个温暖、专业、高效的交流空间。",
  brandStory: "CL社区的诞生源于创始团队对优质在线交流空间的渴望。2018年，几位在互联网行业工作的年轻人发现，虽然社交媒体日益发达，但真正有深度、有价值的交流却变得越来越困难。信息过载、算法茧房、低质内容泛滥——这些问题让认真交流变成了一种奢侈。于是，CL社区应运而生。从最初的几百人小圈子，到如今百万用户的大型社区，CL社区始终坚持「内容为王、用户为本」的理念。",
  values: [
    { title: "真诚交流", description: "我们鼓励每一位成员真诚地表达观点，尊重不同的声音，在友好的氛围中进行有深度的交流。" },
    { title: "内容质量", description: "我们建立了完善的内容审核和推荐机制，确保社区中的每一条内容都对得起读者的时间。" },
    { title: "社区共建", description: "CL社区属于每一位成员。我们欢迎用户参与社区治理，共同维护这片属于大家的交流空间。" },
    { title: "持续创新", description: "技术驱动是我们的基因。我们不断探索新技术，为社区成员提供更优质的交流体验。" },
  ],
  milestones: [
    { year: "2018", event: "CL社区正式上线，首批100名内测用户加入" },
    { year: "2019", event: "注册用户突破10万，开设技术交流和生活分享两大核心板块" },
    { year: "2020", event: "推出移动端App，用户突破50万，新增资源交流板块" },
    { year: "2021", event: "用户突破80万，上线社区积分体系和内容创作者激励计划" },
    { year: "2022", event: "用户突破100万，全面升级社区内容审核和推荐算法" },
    { year: "2023", event: "推出AI辅助内容工具，用户突破115万，新增数码创意板块" },
    { year: "2024", event: "实现社区全面改版，优化移动端体验，日活用户突破5万" },
    { year: "2025", event: "用户突破128万，推出创作者学院，帮助内容创作者成长" },
  ],
  testimonials: [
    { name: "程序猿小明", role: "资深用户 · 加入5年", content: "CL社区是我每天必逛的地方。无论是技术问题求助还是行业资讯获取，这里总有人热情解答。感谢CL社区陪伴我度过了从初级程序员到技术主管的成长之路。" },
    { name: "极简生活家", role: "版主 · 加入4年", content: "作为生活分享板块的版主，我见证了无数温暖的交流时刻。CL社区最特别的地方在于，这里的人是真的在认真交流和分享，而不是为了流量和关注度。" },
    { name: "追光者小李", role: "活跃用户 · 加入3年", content: "考研期间，CL社区的考研互助小组给了我巨大的支持和鼓励。大家一起打卡、分享资料、互相打气，这种并肩作战的感觉真的很棒！" },
  ],
  contact: {
    email: "contact@clshequ.com",
    wechat: "CL社区官方号",
    weibo: "@CL社区官方",
    address: "北京市海淀区中关村科技园创新大厦12层",
    phone: "400-888-XXXX",
    workingHours: "周一至周五 9:00 - 18:00",
  },
};

export const faqs = [
  {
    question: "CL社区如何注册账号？",
    answer: "访问CL社区官网首页，点击右上角的「注册」按钮。您可以使用手机号或邮箱进行注册，填写基本信息后即可完成注册。注册完全免费，整个过程只需1-2分钟。",
  },
  {
    question: "CL社区的内容分区是如何划分的？",
    answer: "CL社区目前设有技术交流、生活分享、资源交流、数码创意、游戏娱乐、学习教育、职场发展、二手交易等八大内容板块。每个板块下还有更细分的标签分类，方便您快速找到感兴趣的内容。",
  },
  {
    question: "如何在CL社区发布内容？",
    answer: "登录账号后，点击首页顶部的「发布」按钮，选择内容类型（帖子、文章、问答等），选择发布板块，编辑内容后即可发布。我们建议您在发布前阅读社区内容规范，以确保内容质量。",
  },
  {
    question: "CL社区的积分体系有什么作用？",
    answer: "CL社区的积分可以通过活跃行为（发帖、回帖、签到等）获得。积分可以用于解锁社区的专属功能、兑换社区周边礼品、参与抽奖活动等。积分也是社区信誉体系的重要组成部分。",
  },
  {
    question: "CL社区如何保证内容质量？",
    answer: "我们建立了多层内容质量管理机制：自动审核系统实时过滤违规内容、社区版主定期巡查、用户举报机制、内容评分和排序算法。这些机制共同保障了CL社区的内容质量。",
  },
  {
    question: "CL社区有移动端App吗？",
    answer: "是的，CL社区拥有iOS和Android双端App。您可以在App Store和各大安卓应用商店搜索「CL社区」下载。App提供了与网页版一致的功能体验，并针对移动端进行了深度优化。",
  },
  {
    question: "如何成为CL社区的版主或管理员？",
    answer: "CL社区定期开放版主招募。申请者需要满足一定的社区活跃度要求，对特定板块有深入了解，并通过社区管理团队的审核。我们欢迎热心用户加入社区管理团队。",
  },
];